import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_61: FaireProductEntity = {
  token: "legacy_prod_abbott-61",
  type: "product",
  name: 'Small Pomegranate Shaped Bowl 4.5" L',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/d33707306a27caef1dae2f0df8296bdbdc31bb44cc537951f31da07ea6dc290a.jpeg",
  priceDollars: 16,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
